import { C } from "../../shared/theme";
import { hue } from "../../shared/hue";
import { intro } from "../../shared/textStyles";

// Each Learn destination wears one hue on its tile and labels (shared with Home).
export { hue };

// The lead-in paragraph style, shared with Home.
export { intro };

// Reasons are amber, strategies teal, everywhere they appear.
export const kindHue = (kind) => hue(kind === "p" ? "amber" : "teal");

export const sectionLabel = (color) => ({
  fontSize: 13, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color, lineHeight: 1.4,
});

export const pageTitle = { margin: 0, fontSize: 26, fontWeight: 800, lineHeight: 1.15 };
export const body = { margin: 0, fontSize: 16, lineHeight: 1.6 };
export const card = () => ({ borderRadius: 16, overflow: "hidden", background: C.surface, border: `1px solid ${C.border}` });
// Learn's one primary button: Nudge green, full width.
export const primaryButton = () => ({
  width: "100%", minHeight: 50, borderRadius: 25, border: "none", background: C.accent, color: C.onAccent,
  fontSize: 16, fontWeight: 700, cursor: "pointer", fontFamily: "inherit",
});
export const resetButton = { border: "none", background: "transparent", fontFamily: "inherit", textAlign: "left", cursor: "pointer", padding: 0 };
